<template>
    <div style="padding: 50px 18px 18px; ">
        <div class="row mb-2">
            <div class="col-12">
                <a href="javascript:void(0)" @click="close" class="float-left">&lt;&lt; Back to messages</a>
            </div>
        </div>
        <div class="row">
            <div class="col-5">
                <select name="available_tags" v-model="availableItemIdx" size="10" class="form-control form-control-sm">
                    <option v-for="(tag, idx) in availableTags" :value="idx" :key="'availableTag' + idx" @dblclick="availableDblClick(idx)">{{tag.label}}</option>
                </select>
            </div>
            <div class="col-2">
                <button class="btn btn-success btn-lg btn-block" @click="buttonSelectAllClick()">
                    >>
                </button>
                <button class="btn btn-success btn-lg btn-block" @click="buttonSelectSingleClick()">
                    >
                </button>

                <button class="btn btn-danger btn-lg btn-block" @click="buttonRemoveSingleClick()">
                    <
                </button>
                <button class="btn btn-danger btn-lg btn-block" @click="buttonRemoveAllClick()">
                    <<
                </button>
            </div>
            <div class="col-5">
                <select name="selected_tags" v-model="selectedItemIdx" size="10" class="form-control form-control-sm">
                    <option v-for="(tag, idx) in localSelectedTags" :value="idx" :key="'localSelectedTag' + idx" @dblclick="selectedDblClick(idx)">{{tag.label}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="float-right">                    
                    <button type="button" class="btn btn-primary mr-2" @click="okClick()">Ok</button>
                    <button type="button" class="btn btn-primary" @click="close()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '@/messageEventBus.js';
    import {
        GET_TAGS_FOR_CLAIM_MESSAGE,
        GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE,
        SET_TAGS_FOR_CLAIM_MESSAGE,
        SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE
    } from '@/messageEvents.js';

    String.prototype.hashCode = function () {
        var hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
            chr = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };

    export default {
        name: "message-tag",
        props: {
            eventTarget: {
                type: String,
                required: true
            },
            messageId: {
                type: Number,
                required: true
            },
            availableTags: {
                type: Array,
                required: true
            },
            selectedTags: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        data: () => {
            return {
                localAvailableTags: [],
                localSelectedTags: [],
                availableItemIdx: null,
                selectedItemIdx: null
            };
        },
        watch: {
        },
        methods: {
            availableDblClick (idx) {
                if (!this.localSelectedTags.includes(this.availableTags[idx]))
                    this.localSelectedTags.push(this.availableTags[idx])
            },
            selectedDblClick (idx) {
                this.localSelectedTags.splice(idx, 1)
            },
            buttonSelectAllClick () {
                for (let i = 0; i < this.availableTags.length; i++) {
                    if (!this.localSelectedTags.includes(this.availableTags[i]))
                    this.localSelectedTags.push(this.availableTags[i])
                }
            },
            buttonRemoveAllClick() {
                this.localSelectedTags = []
            },
            buttonSelectSingleClick() {
                let idx = this.availableItemIdx

                if (!this.localSelectedTags.includes(this.availableTags[idx]))
                    this.localSelectedTags.push(this.availableTags[idx])
            },
            buttonRemoveSingleClick() {
                let idx = this.selectedItemIdx
                if (idx !== null)
                    this.localSelectedTags.splice(idx, 1)
            },
            close() {
                this.$emit("closePanel");
            },
            getEventId() {
                let { messageId } = this
                let base = messageId + new Date().getTime()
                return this.$hashCode(base)
            },
            okClick() {
                let { messageId, localSelectedTags: selectedTags } = this
                let eventId = this.getEventId()

                EventBus.$emit(SET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget, { eventId, messageId, selectedTags })
                EventBus.$once(SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + eventId, (payload) => {
                    console.log(SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + eventId + ': ', payload)
                    //if (payload === true) {
                        this.$emit('closePanel')
                    //}
                    
                });
            }
        },
        beforeMount() {
            EventBus.$emit(GET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget, { id: this.messageId });

            EventBus.$once(GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + this.messageId, (payload) => {
                this.localAvailableTags = payload
                this.localSelectedTags = this.localAvailableTags.filter( t => t.selected == true )
            });
        },
        mounted() {
            //this.localAvailableTags = this.availableTags
            //this.localSelectedTags = this.localAvailableTags.filter( t => t.selected == true )
        }
    };
</script>

